import { num, type ComponentForm } from '../component-types.js';

/** The `animator` component: plays an Animator Controller (engine/docs/systems/animation.md). */
const form: ComponentForm = {
  key: 'animator',
  label: 'Animator',
  icon: 'play',
  order: 65,
  defaults: { controller: '' },
  fields: [
    {
      key: 'controller',
      label: 'Controller',
      hint: 'A *.controller.json (open it to edit states, transitions and blend trees)',
      type: { kind: 'path', suffix: '.controller.json' },
    },
    { key: 'speed', label: 'Speed', hint: 'Playback speed multiplier (1)', type: num(0.05) },
    {
      key: 'applyRootMotion',
      label: 'Apply root motion',
      hint: "Move the entity (character controller / rigidbody / transform) by the root bone's horizontal motion and yaw",
      type: { kind: 'bool' },
    },
    {
      key: 'rootBone',
      label: 'Root bone',
      hint: 'Joint name; empty = hips / pelvis / root',
      type: { kind: 'string', placeholder: 'Hips' },
      showIf: (v) => v.applyRootMotion === true,
    },
    {
      key: 'updateMode',
      label: 'Update mode',
      hint: 'normal: scaled time; unscaledTime: ignores time scale; fixed: in step with physics',
      type: { kind: 'enum', options: ['normal', 'unscaledTime', 'fixed'] },
    },
    {
      key: 'cullingMode',
      label: 'Culling mode',
      hint: 'cullUpdateTransforms: skip pose updates while off screen (state machine keeps running)',
      type: { kind: 'enum', options: ['alwaysAnimate', 'cullUpdateTransforms'] },
    },
    {
      key: 'ik',
      label: 'IK goals',
      hint: '[{ "bone": "foot.L", "target": "LeftFootTarget", "pole": "LeftKneeHint", "chainLength": 2, "weight": 1, "rotation": false }] — after animation the bone reaches the target entity (stable id or name). Scripts: set_ik_goal / clear_ik_goal.',
      type: { kind: 'json' },
    },
    {
      key: 'lookAt',
      label: 'Look at',
      type: {
        kind: 'object',
        fields: [
          { key: 'target', label: 'Target entity', type: { kind: 'string', placeholder: 'Player' } },
          { key: 'weight', label: 'Weight', type: num(0.05), read: (v) => v.weight ?? 1 },
          { key: 'bodyWeight', label: 'Body share', hint: 'Part of the turn taken by spine / chest / neck (the head takes the rest)', type: num(0.05), read: (v) => v.bodyWeight ?? 0.3 },
          { key: 'bones', label: 'Bones', hint: 'Spine first, head last; empty = joints named spine / chest / neck / head', type: { kind: 'json' } },
        ],
      },
    },
  ],
};

export default form;
